import { render, staticRenderFns } from "./LoansTableActions.vue?vue&type=template&id=b1618a86"
import script from "./LoansTableActions.vue?vue&type=script&lang=ts"
export * from "./LoansTableActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports